// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  GenericActionResult,
  GenericActionResultFromJSON,
  GenericActionResultToJSON,
  IssueManagerProfileCapabilities,
  IssueManagerProfileCapabilitiesFromJSON,
  IssueManagerProfileCapabilitiesToJSON,
  IssueManagerResource,
  IssueManagerResourceFromJSON,
  IssueManagerResourceToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CanActAsReporterRequest {
  project: number;
}

export interface GetIssueManagerProfileCapabilitiesRequest {
  id: number;
  refresh?: boolean;
}

export interface GetIssueManagerResourceRequest {
  project: number;
  limit?: number;
  sort?: string;
  start?: number;
  filter?: string;
}

/**
 * no description
 */
export class IssueManagerResourcesApi extends runtime.BaseAPI {
  /**
   * To check if a user can be a reporter for a defect or not in a specific project
   * To check if a user can be a reporter for a defect or not
   */
  async canActAsReporterRaw(
    requestParameters: CanActAsReporterRequest
  ): Promise<runtime.ApiResponse<GenericActionResult>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling canActAsReporter."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuemanagerprofiles/canActAsReporter`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GenericActionResultFromJSON(jsonValue)
    );
  }

  /**
   * To check if a user can be a reporter for a defect or not in a specific project
   * To check if a user can be a reporter for a defect or not
   */
  async canActAsReporter(
    requestParameters: CanActAsReporterRequest
  ): Promise<GenericActionResult> {
    const response = await this.canActAsReporterRaw(requestParameters);
    return await response.value();
  }

  /**
   * Probes the live Azure DevOps APIs to report whether this connection can read work items, read deployments and pipelines, and manage service hooks. The result is persisted on the profile with a refresh timestamp. Only supported for Azure DevOps connections.
   * Detect what an Azure DevOps connection is allowed to do
   */
  async getIssueManagerProfileCapabilitiesRaw(
    requestParameters: GetIssueManagerProfileCapabilitiesRequest
  ): Promise<runtime.ApiResponse<IssueManagerProfileCapabilities>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getIssueManagerProfileCapabilities."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.refresh !== undefined) {
      queryParameters["refresh"] = requestParameters.refresh;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuemanagerprofiles/{id}/capabilities`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IssueManagerProfileCapabilitiesFromJSON(jsonValue)
    );
  }

  /**
   * Probes the live Azure DevOps APIs to report whether this connection can read work items, read deployments and pipelines, and manage service hooks. The result is persisted on the profile with a refresh timestamp. Only supported for Azure DevOps connections.
   * Detect what an Azure DevOps connection is allowed to do
   */
  async getIssueManagerProfileCapabilities(
    requestParameters: GetIssueManagerProfileCapabilitiesRequest
  ): Promise<IssueManagerProfileCapabilities> {
    const response = await this.getIssueManagerProfileCapabilitiesRaw(
      requestParameters
    );
    return await response.value();
  }

  /**
   * Get list of projects from the specified linked issue manager
   * Get list of projects from issue manager
   */
  async getIssueManagerResourceRaw(
    requestParameters: GetIssueManagerResourceRequest
  ): Promise<runtime.ApiResponse<IssueManagerResource>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getIssueManagerResource."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuemanagerprofiles/getResource`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IssueManagerResourceFromJSON(jsonValue)
    );
  }

  /**
   * Get list of projects from the specified linked issue manager
   * Get list of projects from issue manager
   */
  async getIssueManagerResource(
    requestParameters: GetIssueManagerResourceRequest
  ): Promise<IssueManagerResource> {
    const response = await this.getIssueManagerResourceRaw(requestParameters);
    return await response.value();
  }
}
